import React, { Component } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import TimeAgo from 'react-timeago';

import { _firestore } from '../../firebase';
import Ratings from '../../components/Ratings';
import starGray from '../../assets/images/star-gray.svg';
import starYellow from '../../assets/images/star-yellow.svg';

class UserReviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allReviews: [],
      isLoading: false,
      showEnterAnimation: true,
      showAnimation: false,
      width: window.innerWidth,
      allLoaded: false,
    };
  }
  componentDidMount() {
    const { storeConfig } = this.props;
    this.setState({
      showLoader: true,
    });
    window.addEventListener('resize', this.handleWindowSizeChange, true);

    let nextRef = _firestore
      .collection('Reviews')
      .where('storeId', '==', storeConfig.storeId)
      .where('isVisible', '==', true)
      .orderBy('dateTimestamp', 'desc')
      .limit(25);

    nextRef.get().then((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((doc) => {
        dataArray.push({ _id: doc.id, ...doc.data() });
      });

      this.setState({
        allReviews: dataArray,
        isLoading: false,
        showLoader: false,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.review) {
      this.setState({ showEnterAnimation: true, showAnimation: false });
      setTimeout(() => {
        this.setState({ showEnterAnimation: false });
      }, 500);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange, true);
  }

  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  showAnimationBeforeClose = () => {
    this.setState(
      {
        showAnimation: true,
      },
      () => {
        setTimeout(() => {
          this.props.closeReview();
        }, 300);
      }
    );
  };

  handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

    if (
      this.props.reviewStats &&
      this.props.reviewStats.totalReviews &&
      this.state.allReviews.length < this.props.reviewStats.totalReviews
    ) {
      if (bottom) {
        this.loadReviews(this.props.reviewStats.totalReviews);
      }
    }
  };

  loadReviews = (totalReviews) => {
    const { storeConfig } = this.props;
    this.setState({
      showLoader: true,
    });

    let limit =
      this.state.allReviews.length + 10 < totalReviews
        ? this.state.allReviews.length + 10
        : totalReviews;

    let nextRef = _firestore
      .collection('Reviews')
      .where('storeId', '==', storeConfig.storeId)
      .orderBy('dateTimestamp', 'desc')
      .limit(limit);

    nextRef.get().then((querySnapshot) => {
      var dataArray = [];
      querySnapshot.forEach((doc) => {
        dataArray.push({ _id: doc.id, ...doc.data() });
      });

      this.setState(
        {
          allReviews: dataArray,
          showLoader: false,
        },
        () => {
          if (dataArray.length === totalReviews) {
            this.setState({
              allLoaded: true,
            });
          }
        }
      );
    });
  };

  getReviewPercentage = (rating) => {
    if (
      this.props.reviewStatsByRating &&
      this.props.reviewStatsByRating.length > 0 &&
      this.props.reviewStats
    ) {
      let rList = this.props.reviewStatsByRating.filter((f) => {
        return Number(f.rating) === rating;
      });
      if (rList.length > 0)
        return (
          (rList[0].totalReviews * 100) / this.props.reviewStats.totalReviews
        );
      else return 0;
    }
    return 0;
  };
  isInt = (value) => {
    var er = /^-?[0-9]+$/;
    return er.test(value);
  };

  render() {
    const { open, close } = this.props;

    const transitionStyles = {
      entering: { transform: `translateX(100%)` },
      entered: { transform: `translateX(0)` },
      exiting: { transform: `translateX(100%)` },
      exited: { transform: `translateX(100%)`, display: `none` },
    };

    return (
      <Transition timeout={250} mountOnEnter unmountOnExit in={open}>
        {(state) => (
          <div
            className='userReviewWrap'
            style={{
              zIndex: 10000,
              position: `absolute`,
              width: `100%`,
              height: `100%`,
              background: `white`,
              top: 0,
              left: 0,
              right: 0,
              transition: `transform .25s ease-out`,
              ...transitionStyles[state],
            }}
          >
            <div
              className='backToOrder thickcon-Left-Chevron'
              onClick={close}
            />
            <div className='detailsTitle uR' style={{ marginTop: 0 }}>
              Reviews
            </div>
            {this.props.reviewStats?.averageRating && (
              <Ratings
                rating={
                  this.props.reviewStats.averageRating
                    ? Number(this.props.reviewStats.averageRating).toFixed(1)
                    : 0
                }
              />
            )}
            {this.state.width <= 1024 && (
              <div className='uRstarC'>
                <div className='uRleftC'>
                  <div>
                    {this.props.reviewStats?.averageRating
                      ? Number(this.props.reviewStats.averageRating).toFixed(1)
                      : 'N/A'}
                  </div>
                  <div>out of 5</div>
                </div>
                <div className='uRrightC'>
                  <div className='uRstarMain'>
                    <div className='urRow'>
                      <div className='urLeftSec'>
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                      </div>
                      <div className='urRightSec'>
                        <div className='progressBar'>
                          <div
                            className='prgFill'
                            style={{ width: `${this.getReviewPercentage(5)}%` }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='urRow'>
                      <div className='urLeftSec'>
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                      </div>
                      <div className='urRightSec'>
                        <div className='progressBar'>
                          <div
                            className='prgFill'
                            style={{ width: `${this.getReviewPercentage(4)}%` }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='urRow'>
                      <div className='urLeftSec'>
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                      </div>
                      <div className='urRightSec'>
                        <div className='progressBar'>
                          <div
                            className='prgFill'
                            style={{ width: `${this.getReviewPercentage(3)}%` }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='urRow'>
                      <div className='urLeftSec'>
                        <img src={starYellow} alt='' />
                        <img src={starYellow} alt='' />
                      </div>
                      <div className='urRightSec'>
                        <div className='progressBar'>
                          <div
                            className='prgFill'
                            style={{ width: `${this.getReviewPercentage(2)}%` }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='urRow'>
                      <div className='urLeftSec'>
                        <img src={starYellow} alt='' />
                      </div>
                      <div className='urRightSec'>
                        <div className='progressBar'>
                          <div
                            className='prgFill'
                            style={{ width: `${this.getReviewPercentage(1)}%` }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='uRRev'>
                    {this.props.reviewStats &&
                    this.props.reviewStats.totalReviews
                      ? this.props.reviewStats.totalReviews
                      : 0}
                    Reviews
                  </div>
                </div>
              </div>
            )}
            <div
              id='reviewListWrap'
              onScroll={this.handleScroll}
              className={
                this.state.showLoader
                  ? 'reviewListWrap loading'
                  : 'reviewListWrap'
              }
            >
              {this.state.allReviews &&
                !this.state.isLoading &&
                this.state.allReviews.map((r, i) => (
                  <React.Fragment key={`UserReview-${i}`}>
                    {r.isVisible === true && (
                      <div
                        key={i}
                        className={`${
                          this.state.allLoaded === true
                            ? `reviewListItem allReviewsLoaded`
                            : `reviewListItem`
                        }`}
                      >
                        <div className='rlTitleWrap'>
                          <div className='rlTitle'>
                            {r.firstName ? r.firstName : r.userName}
                          </div>
                          <div className='rlrating'>
                            {new Array(Number(r.rating)).fill().map((_, p) => (
                              <img key={p} src={starYellow} alt='' />
                            ))}
                            {new Array(5 - Number(r.rating))
                              .fill()
                              .map((_, p) => (
                                <img key={p} src={starGray} alt='' />
                              ))}
                          </div>
                        </div>
                        <div className='rlDate'>
                          <TimeAgo date={r.dateTimestamp} live={false} />
                        </div>
                        <div className='rlRating'>{r.comment && r.comment}</div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        )}
      </Transition>
    );
  }
}

UserReviews.propTypes = {
  reviewStats: PropTypes.any,
  reviewStatsByRating: PropTypes.any,
};

export default UserReviews;
